import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdminService } from 'src/app/core/services/api/admin.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-missing-cb-medicines',
  templateUrl: './missing-cb-medicines.component.html',
  styleUrls: ['./missing-cb-medicines.component.scss']
})
export class MissingCbMedicinesComponent implements OnInit {
  retailerCode: string = "";
  loading: boolean = false;
  downloading: boolean = false;
  errorMessage: string = "";
  medicines: any[] = [];

  totalCount: number = 0;

  constructor(
    public dialogRef: MatDialogRef<MissingCbMedicinesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { retailerCode: string },
    private adminService: AdminService
  ) { }

  ngOnInit(): void {
    if (this.data && this.data.retailerCode) {
      this.retailerCode = this.data.retailerCode;
      this.fetchMissingMedicines();
    } else {
      this.errorMessage = "Retailer Code is required.";
    }
  }

  fetchMissingMedicines(): void {
    this.loading = true;
    this.errorMessage = "";
    this.medicines = [];
    this.totalCount = 0;

    this.adminService.getMissingCbMedicines(this.retailerCode).subscribe(
      (response) => {
        this.loading = false;
        if (response && response.data) {
          if (response.data.medicines && Array.isArray(response.data.medicines)) {
            this.medicines = response.data.medicines;
          } else if (Array.isArray(response.data)) {
            this.medicines = response.data;
          } else if (response.data.content && Array.isArray(response.data.content)) {
            this.medicines = response.data.content;
          } else {
            this.medicines = [response.data];
          }

          if (response.data.totalCount !== undefined) {
            this.totalCount = response.data.totalCount;
          } else {
            this.totalCount = this.medicines.length;
          }
        } else {
          this.medicines = [];
          this.totalCount = 0;
        }
      },
      (error) => {
        this.loading = false;
        this.errorMessage = error?.error?.error || error?.message || "Failed to fetch missing medicines.";
      }
    );
  }

  download(): void {
    if (!this.retailerCode) return;
    this.downloading = true;
    this.errorMessage = "";

    this.adminService.downloadMissingCbMedicines(this.retailerCode).subscribe(
      (response) => {
        this.downloading = false;
        const blob = response.body;
        let filename = `missing_cb_medicines_${this.retailerCode}.csv`;
        
        // Try to get filename from content-disposition header if available
        const contentDisposition = response.headers.get("content-disposition");
        if (contentDisposition && contentDisposition.includes("=")) {
          const parts = contentDisposition.split('=');
          if (parts.length > 1) {
            filename = parts[1].replace(/['"]/g, ''); // strip any quotes
          }
        }
        
        FileSaver.saveAs(blob, filename);
      },
      (error) => {
        this.downloading = false;
        this.errorMessage = error?.error?.error || error?.message || "Failed to download missing medicines CSV.";
      }
    );
  }

  close(): void {
    this.dialogRef.close();
  }
}
